import { call, take, put } from 'redux-saga/effects';
import { get , post } from '../../utils/api';
import settings from '../../utils/settings';
import { apiConfig } from './apiConfig';
import {
  GET_CELL_MODEM_LIST_REQUEST,
  GET_CELL_MODEM_LIST_SUCCESS,
  GET_CELL_MODEM_LIST_FAILURE,
  EXTEND_DATA_PLAN_REQUEST,
  EXTEND_DATA_PLAN_SUCCESS,
  EXTEND_DATA_PLAN_FAILURE,
  GET_PRICES_REQUEST,
  GET_PRICES_SUCCESS,
  GET_PRICES_FAILURE,
  GET_FEEDBACK_REQUEST,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
  POST_FEEDBACK_REQUEST,
  POST_FEEDBACK_SUCCESS,
  POST_FEEDBACK_FAILURE
} from './constants';

export function* getCellModemListFlow() {
  while (true) {
    const request = yield take(GET_CELL_MODEM_LIST_REQUEST);
    try {
      const response = yield call(post, {
        url: `${settings.getApiUrl(`service/modem/${apiConfig.cell_modem_list}`)}`,
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_CELL_MODEM_LIST_SUCCESS,
            cellModemList: response.result
          });
        } else {
          yield put({ type: GET_CELL_MODEM_LIST_FAILURE, error: result.message });
        }
      }else{
        const { result } = response;
        yield put({ type: GET_CELL_MODEM_LIST_FAILURE, error: result?.message });
      }
    } catch (error) {
      console.log('saga: getCellModemListFlow:', error);
      yield put({ type: GET_CELL_MODEM_LIST_FAILURE, error: error });
    }
  }
}

export function* extendDataPlanFlow() {
  while (true) {
    const request = yield take(EXTEND_DATA_PLAN_REQUEST);
    try {
      const response = yield call(post, {
        url: `${settings.getApiUrl(`service/modem/${apiConfig.extend_data_plan}`)}`,
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: EXTEND_DATA_PLAN_SUCCESS,
            extend_data_plan: response.result
          });
        } else {
          yield put({ type: EXTEND_DATA_PLAN_FAILURE, error: result.message });
        }
      }else{
        const { result } = response;
        yield put({ type: EXTEND_DATA_PLAN_FAILURE, error: result?.message });
      }
    } catch (error) {
      console.log('saga: extendDataPlanFlow:', error);
      yield put({ type: EXTEND_DATA_PLAN_FAILURE, error: error });
    }
  }
}

export function* getPricesFlow() {
  while (true) {
    const request = yield take(GET_PRICES_REQUEST);
    // const isProductionEnlm = (window.build_environment === 'production')
    // const isQa4ENLM = (window.build_environment === 'qa4')
    // console.log("Process.env.node_env:", process.env.NODE_ENV)
    // console.log("process.env.REACT_APP_BUILD_ENV", process.env.REACT_APP_BUILD_ENV)
    try {
      const response = yield call(post, {
        url: `${settings.getApiUrl(`service/modem/${apiConfig.prices}`)}`,
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_PRICES_SUCCESS,
            prices: response.result
          });
        } else {
          yield put({ type: GET_PRICES_FAILURE, error: result.message });
        }
      }else{
        const { result } = response;
        yield put({ type: GET_PRICES_FAILURE, error: result?.message });
      }
    } catch (error) {
      console.log('saga: getPricesFlow:', error);
      yield put({ type: GET_PRICES_FAILURE, error: error });
    }
  }
}

export function* getPostFeedbackForm() {
  while (true) {
    const request = yield take(POST_FEEDBACK_REQUEST);
    try {
      const response = yield call(post, {
        url: `${settings.getApiUrl(`service/modem/${apiConfig.feedback_post_call}`)}`,
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: POST_FEEDBACK_SUCCESS,
            getFeedbackresult: result.feedbackSubmitted
          });
        } else {
          yield put({ type: POST_FEEDBACK_FAILURE, error: result.message });
        }
      }else{
        const { result } = response;
        yield put({ type: POST_FEEDBACK_FAILURE, error: result?.message });
      }
    } catch (error) {
      console.log('saga: getPostFeedbackForm:', error);
      yield put({ type: POST_FEEDBACK_FAILURE, error: error });
    }
  }
}

 export function* getFeedbackGiven() {
  while (true) {
    yield take(GET_FEEDBACK_REQUEST);
    try {
      let response;
      response = yield call(get, {
       url: `${settings.getApiUrl(`service/modem/${apiConfig.feedback_post_call}`)}`,
      });

      if (response.success) {
        const { result } = response;
        yield put({ type: GET_FEEDBACK_SUCCESS, getFeedbackresult: result.feedbackSubmitted});
      }
    } catch (error) {
      console.log('Saga: getFeedbackGiven:', error);
      yield put({ type: GET_FEEDBACK_FAILURE, error: error });
    }
  }
}